import { Link } from 'react-router-dom';
import Simple from '../../components/Layout/Simple';

export default function NotFound(): JSX.Element {
  document.title = `${process.env.REACT_APP_TITLE}: Not found`;

  return (
    <Simple>
      <div style={{ textAlign: 'center' }}>
        <div>Not found</div>
        <Link to="/" replace>
          Go to home page
        </Link>
      </div>
    </Simple>
  );
}
